import { LoadingButton, LoadingButtonProps } from '@mui/lab'
import {
  Button,
  ButtonProps,
  Dialog,
  DialogProps,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogTitleProps,
  IconButton,
  IconButtonProps
} from '@mui/material'
import { Close } from 'mdi-material-ui'
import React, { ReactNode } from 'react'

interface GenericDialogProps {
  open: boolean
  title: string | ReactNode
  onClose: () => void
  onCancel?: () => void
  onSave?: () => void
  cancelButtonText?: string
  saveButtonText?: string
  children?: ReactNode
  loading?: boolean
  disabled?: boolean
  dialogProps?: Partial<DialogProps>
  cancelButtonProps?: Partial<ButtonProps>
  saveButtonProps?: Partial<LoadingButtonProps>
  closeIconButtonProps?: Partial<IconButtonProps>
  dialogTitleProps?: Partial<
    DialogTitleProps & {
      color?: 'black'
      variant?: 'h5'
      sx?: {
        padding?: string
        fontWeight?: number
        display?: string
        alignItems?: string
        justifyContent?: string
      }
    }
  >
}

export default function GenericDialog({
  open,
  title,
  onClose,
  onCancel,
  onSave,
  cancelButtonText = 'Cancel',
  saveButtonText = 'Save',
  children,
  loading = false,
  disabled = false,
  dialogProps = {
    PaperProps: {
      style: { borderRadius: 16 }
    }
  },
  cancelButtonProps = {
    size: 'medium',
    variant: 'text',
    color: 'primary',
    sx: { fontSize: 16 }
  },
  saveButtonProps = {
    size: 'medium',
    loadingPosition: 'end',
    variant: 'contained',
    color: 'primary',
    sx: { fontSize: 16, outline: 'none' }
  },
  closeIconButtonProps,
  dialogTitleProps = {
    color: 'black',
    variant: 'h5',
    sx: {
      padding: '1rem',
      fontWeight: 600,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }
}: GenericDialogProps) {
  return (
    <>
      <Dialog open={open} onClose={onClose} {...dialogProps}>
        <DialogTitle {...dialogTitleProps}>
          {title}
          <IconButton aria-label='close' onClick={onClose} {...closeIconButtonProps}>
            <Close color={'secondary'} sx={{ height: 24, width: 24 }} />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 4, padding: '1.5rem 1rem' }}>
          {children}
        </DialogContent>
        <DialogActions
          sx={{
            padding: '1.5rem',
            gap: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end'
          }}
        >
          <Button onClick={onCancel} {...cancelButtonProps}>
            {cancelButtonText}
          </Button>
          <LoadingButton disabled={disabled} onClick={onSave} {...saveButtonProps} loading={loading}>
            {saveButtonText}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  )
}
